import { orderBy } from "lodash-es";

const getPlaceID = geoLocation => {
  return new Promise((resolve, reject) => {
    $.get({
      url: `/api/v5/google_map/find_place_id.json?lat=${geoLocation.lat}&lng=${geoLocation.lng}`,
      success: (response) => {
        if (response.success) {
          const placeId = response.data.place_id;
          resolve(placeId);
        } else {
          const error = {
            data: response,
            cause: "Google map API return wrong format",
            message: "failed get place ID from lat, lng"
          };
          window.Rollbar.error(error.message, {
            message: error.cause,
            data: error.data
          });
          reject(error);
        }
      },
      error: (err) => {
        const error = {
          data: err,
          cause: err,
          message: "failed to get place ID from lat, lng"
        };
        window.Rollbar.error(error.message, {
          message: error.cause,
          data: error.data
        });
        reject(error);
      }
    });
  });
};

const getPlaceDetail = placeId => {
  return new Promise((resolve, reject) => {
    try {
      const placeService = new window.google.maps.places.PlacesService(
        document.createElement("div")
      );
      placeService.getDetails(
        {
          placeId,
          fields: [
            "name",
            "formatted_address",
            "geometry.location",
            "address_components"
          ],
        },
        (place) => {
          if (!place) {
            const error = {
              data: place,
              cause: "Google map API return wrong format",
              message: "failed get place detail from place ID"
            };
            window.Rollbar.error(error.message, {
              message: error.cause,
              data: error.data
            });
            reject(error);
          } else {
            let countryCode = "";
            let address_components = place.address_components;
            for (let i = 0; i < address_components.length; i++) {
              let types = address_components[i].types;
              for (let j = 0; j < types.length; j++) {
                if (types[j] === "country") {
                  countryCode = address_components[i].short_name;
                }
              }
            }
            const selectedLocation = {
              placeName: place.name,
              detail: place.formatted_address,
              lat: place.geometry.location.lat(),
              lng: place.geometry.location.lng(),
              countryCode
            };
            resolve(selectedLocation);
          }
        }
      );
    } catch (err) {
      const error = {
        data: err,
        cause: err,
        message: "failed get place detail from place ID"
      };
      window.Rollbar.error(error.message, {
        message: error.cause,
        data: error.data
      });
      reject(error);
    }
  });
};

const askUseCurrentLocation = () => {
  return new Promise((resolve, reject) => {
    if (navigator.geolocation) {
      const option = {
        enableHighAccuracy: true,
        timeout: 5000
      };
      navigator.geolocation.getCurrentPosition(
        parsePoisition,
        errorGetPosition,
        option
      );
      function parsePoisition(position) {
        const geoLocation = {};
        geoLocation.lat = position.coords.latitude;
        geoLocation.lng = position.coords.longitude;
        resolve(geoLocation);
      }
      function errorGetPosition(param) {
        const error = {
          data: param,
          message: "Please allow browser to access your current location",
          cause: param
        };
        reject(error);
      }
    } else {
      resolve();
    }
  });
};

const getAddress = geoLocation => {
  return new Promise((resolve, reject) => {
    if (geoLocation === null) {
      const error = {
        data: geoLocation,
        cause: "Required parammter 'geo location' not found",
        message: "failed get place detail from place ID"
      };
      window.Rollbar.error(error.message, {
        message: error.cause,
        data: error.data
      });
      reject(error);
    } else {
      try {
        // call the function
        getPlaceID(geoLocation)
          .then(placeId => {
            getPlaceDetail(placeId).then(selectedLocation => {
              resolve(selectedLocation);
            });
          })
          .catch(err => {
            const error = {
              data: err,
              cause: err,
              message: "failed get Address"
            };
            window.Rollbar.error(error.message, {
              message: error.cause,
              data: error.data
            });
            reject(error);
          });
      } catch (err) {
        const error = {
          data: err,
          cause: err,
          message: "failed get Address"
        };
        window.Rollbar.error(error.message, {
          message: error.cause,
          data: error.data
        });
        reject(error);
      }
    }
  });
};

const getDistanceToRestaurant = payload => {
  return new Promise((resolve, reject) => {
    try {
      const lat = payload.currentAddress.lat;
      const lng = payload.currentAddress.lng;
      const restLat = payload.restaurantAddress.lat;
      const restLng = payload.restaurantAddress.lng;

      const directionsService = new google.maps.DirectionsService();
      directionsService.route(
        {
          origin: new window.google.maps.LatLng(restLat, restLng),
          destination: new window.google.maps.LatLng(lat, lng),
          travelMode: "DRIVING",
          avoidTolls: true,
          provideRouteAlternatives: true,
          unitSystem: google.maps.UnitSystem.METRIC
        },
        (response, status) => {
          if (status === "OK") {
            if (response.routes.length > 0) {
              const arrayOfDistance = response.routes.map(route => {
                return route.legs[0];
              });
              const shortedDistanceFirst = orderBy(
                arrayOfDistance,
                "distance.value"
              );
              resolve(shortedDistanceFirst[0].distance);
            } else {
              const error = {
                cause: "No routes found from user to restaurant",
                message:
                  "Ops, no routes found from your location to the restaurant"
              };
              window.Rollbar.error(error.message, error.cause);
              reject(error);
            }
          } else if (status === "ZERO_RESULTS") {
            const error = {
              cause: "No routes found from user to restaurant",
              message:
                "Ops, no routes found from your location to the restaurant"
            };
            window.Rollbar.error(error.message, error.cause);
            reject(error);
          } else {
            const error = {
              cause: response,
              message: "Ops, something went wrong, failed to calculate distance"
            };
            window.Rollbar.error(error.message, error.cause);
            reject(error);
          }
        }
      );
    } catch (err) {
      const error = {
        cause: err,
        message: "Ops, something went wrong, failed to calculate distance"
      };
      Rollbar.error(error.message, error.cause);
      reject(error);
    }
  });
};

export {
  askUseCurrentLocation,
  getAddress,
  getPlaceID,
  getPlaceDetail,
  getDistanceToRestaurant
};
